"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignRuleSchema = void 0;
exports.parseDru = parseDru;
const lengthAttributes = [
    'mdWireWire',
    'mdWirePad',
    'mdWireVia',
    'mdPadPad',
    'mdPadVia',
    'mdViaVia',
    'mdSmdPad',
    'mdSmdVia',
    'mdSmdSmd',
    'mdViaViaSameLayer',
    'mdCopperDimension',
    'mdDrill',
    'mdSmdStop',
    'msWidth',
    'msDrill',
    'msMicroVia',
    'rlMinPadTop',
    'rlMaxPadTop',
    'rlMinPadInner',
    'rlMaxPadInner',
    'rlMinPadBottom',
    'rlMaxPadBottom',
    'rlMinViaOuter',
    'rlMaxViaOuter',
    'rlMinViaInner',
    'rlMaxViaInner',
    'rlMinMicroViaOuter',
    'rlMaxMicroViaOuter',
    'rlMinMicroViaInner',
    'rlMaxMicroViaInner',
    'mlMinStopFrame',
    'mlMaxStopFrame',
    'mlMinCreamFrame',
    'mlMaxCreamFrame',
    'mlViaStopLimit',
    'srMinRoundness',
    'srMaxRoundness',
    'slMinThermalGap',
    'slMaxThermalGap',
    'slAnnulusIsolate',
    'slThermalIsolate',
];
function parseDru(dru) {
    const result = {};
    const lines = dru.split('\n');
    lines.forEach((line) => {
        const [name, value] = line
            .split('=')
            .map((v) => v.trim())
            .filter((v) => v.length);
        if ('layerSetup' === name) {
            result.layerSetup = value;
        }
        else if ('mtCopper' === name) {
            result.mtCopper = value.split(' ').map((v) => formatMeasurement(v));
        }
        else if ('mtIsolate' === name) {
            result.mtIsolate = value.split(' ').map((v) => formatMeasurement(v));
        }
        else if (lengthAttributes.includes(name)) {
            result[name] = formatMeasurement(value);
        }
        else {
            result[name] = parseFloat(value);
        }
    });
    return result;
}
function formatMeasurement(value) {
    if (value.endsWith('mil')) {
        return parseFloat(value.substr(0, value.length - 3)) / 39.37;
    }
    return parseFloat(value.substr(0, value.length - 2));
}
class DesignRuleSchema {
}
exports.DesignRuleSchema = DesignRuleSchema;
//# sourceMappingURL=dru.js.map